export const ICONS = {
  hobby: 'goal',
  play: 'tennis',
  work: 'article',
  other: 'target',
  no_pain: 'no-pain',
  sleep_quality: 'sleep',
  no_surgery: 'no-surgery',
  physical_fitness: 'strength',
  pain_prevention: 'shield-alt',
  no_medication: 'no-medication',
  mental_wellbeing: 'mental-health',
  exercise_routine: 'exercise-routine',
  better_bladder_control_with_movements: 'bladder_control_with_movements',
  reduce_frequent_urges_to_pee: 'urges_to_bathroom',
  empty_bowel: 'empty_bowel',
  reduce_straining_with_bowel_movements: 'straining_with_bowel_movements',
  reduce_leaking_stool: 'leaking_stool',
  reduce_pain_when_in_bathroom: 'pain_when_in_bathroom',
  reduce_pain_everyday_activities: 'pain_everyday_activities',
  reduce_vaginal_pain_or_sensitivity: 'vaginal_pain_or_sensitivity',
  reduce_hip_or_buttock_pain: 'hip_or_buttock_pain',
  hurry_to_the_bathroom: 'hurry_to_the_bathroom',
  reduce_pain_pelvic_cramping: 'vaginal_pain_or_sensitivity_tension',
  reduce_other_pelvic_symptoms: 'pelvic_health',
  reduce_pain_with_urination: 'pelvic_pain',
  reduce_constipation: 'urges_to_bathroom',
  reduce_pain_bowel_movements: 'urges_to_bathroom',
  reduce_diarrhea_lose_stool: 'fecal_leakage',
  reduce_abdominal_pain_bloating: 'vaginal_pain_or_sensitivity_tension',
  reduce_bowel_movement_regularity: 'empty_bowel_completely',
  improve_abdominal_disconfort: 'straining_with_bowel_movements',
  reduce_abdominal_groin_pain: 'pelvic_health',
}
